module.exports = __webpack_public_path__ + "simquadrat_name.svg?98ac6dbd7bcdc2b721a43d6fae86de20";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/simquadrat_name.svg
// module id = 18
// module chunks = 0